<template>
  <div class="banner-pc">
    <a-carousel autoplay>
      <div v-for="item in bannerList" :key="item.id" class="banner-item">
        <img :src="require(`@/assets/images/banner-${item.id}.png`)" alt="">
        <div class="banner-text">
          <div :style="`color: ${item.color}`">{{item.ch}}</div>
          <div :style="`color: ${item.color}`">{{item.en}}</div>
        </div>
      </div>
    </a-carousel>
  </div>
</template>

<script>
import bannerList from '@/assets/js/static/banner-list.js'

export default {
  name: 'banner-pc',

  data () {
    return {
      bannerList
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-pc {
  .ant-carousel {
    .banner-item {
      position: relative;

      img {
        display: inline-block;
        height: 752px;
      }

      .banner-text {
        position: absolute;
        top: 50%;
        transform:translateY(-50%);
        width: 100%;
        text-align: center;

        div {
          &:nth-child(1) {
            margin-bottom: 14px;
            line-height: 47px;
            font-size: 40px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
          }

          &:nth-child(2) {
            font-size: 16px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            line-height: 19px;
          }
        }
      }
    }
  }
}
</style>
